// import { useState } from 'react'
// import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { WafFriendlyPass } from 'src/types/waf-friendly-pass'
// import { RecoilAtomKeys } from 'src/utils/recoil/keys'
import { wpApiUrl } from 'src/utils/wpApiUrl'

import useSwr from 'swr'

type spotTypeListType = WafFriendlyPass.taxonomy[]

const fetcher = (url: string) => {
  const response = fetch(url).then(
    async (res) => res.json() as unknown as spotTypeListType
  )
  return response
}
const useSpotTypeList = () => {
  const { data, error } = useSwr(`${wpApiUrl.taxonomySpotType}`, fetcher)
  return { data, error }
}

export { useSpotTypeList }
